import { REQUESTED, APPROVED, REJECTED, NO_STATUS } from './receivers-statuses-id';

export const statusLookup: Array<any> = [
  { id: REJECTED, status: 'Rejected'},
  { id: REQUESTED, status: 'Requested'},
  { id: APPROVED, status: 'Approved'},
  { id: NO_STATUS, status: 'No Status'},
];
